<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="部门:" v-if="dpts">
              <el-select
                v-model="searchParams.dept"
                @change="search(3)"
                placeholder="请选择部门"
              >
                <el-option
                  v-for="item in dpts"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="10" class="box">
            <div class="box2">
              <el-button type="primary" @click="search(-41)" v-if="empidx > 1">
                《《
              </el-button>
              <el-select v-model="empidx" @change="search(4)" v-if="emps">
                <el-option
                  v-for="(item, idx) in emps"
                  :key="idx"
                  :label="item.name"
                  :value="idx"
                >
                </el-option>
              </el-select>
              <el-button
                type="primary"
                @click="search(41)"
                v-if="isCanShEmpNxt()"
                >》》</el-button
              >
            </div>

            <div class="box2">
              <el-date-picker
                v-model="month"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                @change="search(1)"
              >
              </el-date-picker>
            </div>
          </el-col>
            <el-col :span="2" class="box">
 	         <el-button @click="clearSearchVal">清空</el-button>
 </el-col>
        </el-row>
      </el-form>

    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <qlh-table
        class="table"
        :data="listData.records"
        stripe
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >

         <qlh-table-column type="index" label="序号"></qlh-table-column>
		     <qlh-table-column prop="month" label="月份">   </qlh-table-column>
         <qlh-table-column prop="name"  label="填报人"  ></qlh-table-column>
         <qlh-table-column prop="pnm" label="业绩名称"></qlh-table-column>
         <qlh-table-column prop="cnt" label="业绩数量"> </qlh-table-column>
         
      </qlh-table>

      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>

      </div>
    </div>
  </div>
</template>

<script>

import qlhTable from '@/components/qlhTable/qlhTable.vue';
import qlhTableColumn from '@/components/qlhTable/qlhTableColumn.vue';
import api from '@/api/oa/wkreport.js';
export default {
	name: 'wkreportachi',
	components: {
       qlhTable,
       qlhTableColumn,
	},
	data() {
    return {
      formLabelWidth: "120px",
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      
      dpts: undefined,
      emps: undefined,
      empidx: 0, //当前的用户
      month: "",
      me: {}
    };
  },
  methods: {
    // 员工导航是否显示下一位
    isCanShEmpNxt() {
      if (this.emps) {
        return this.empidx < this.emps.length - 1;
      }
      return false;
    },
    //获取数据
    list() {
      this.listLoading = true;

      if (this.month &&( Date == typeof this.month)) {
        this.searchParams.month = this.month.format("yyyy-MM");
      }

      let params = this.$utils.merger(this.searchParams, this.page);
 
      api.achivelist(params, (response) => {
 
        // 总经理
        if (response.data.dpts) {
          this.dpts = response.data.dpts;
        }
        // 总经理  +总监
        if (response.data.emps) {
          this.emps = response.data.emps;
        }

        this.listData = response.data.data;

        this.listLoading = false;
      });
    },

    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search(type) {
      if (type) {
        if (type == 1) {
    
          // 时间选择器
          this.searchParams.month = this.month;
        } else if (type == 3) {
          // 部门选择器
          this.searchParams.usrid = "全部人";
        } else if (type == 4) {
          // 员工选择器
          this.searchParams.usrid = this.emps[this.empidx].id;
        } else if (type == -41) {
          // 上1员工
          this.empidx--;
          this.searchParams.usrid = this.emps[this.empidx].id;
        } else if (type == 41) {
          // 下1员工
          this.empidx++;
          this.searchParams.usrid = this.emps[this.empidx].id;
        }
      }
      this.list();
    },
    clearSearchVal() {
      this.searchParams = {};
      this.month=""
      this.list();
    },
  },
  mounted() {
    // 前端取回自己
    this.me = this.$caches.user.get();

    //总经理
    if ("admin" == this.me.role2||"admin2" == this.me.role2) {
      this.searchParams = { dept: "靖凯开源", usrid: "全部人" };
      //部门经理
    } else if ("mgr" == this.me.role2 || "mgr2" == this.me.role2 || "mgr3" == this.me.role2) {
      this.searchParams = { usrid: "全部人" };
    }

    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
  @import "~common/custom/css/common.scss";

  .box {
  display: flex;
}
.box2 {
  display: flex;
  margin: 0px 10PX;
}
</style>

